import { executiveAlerts } from './dashboard.data';

export const ExecutiveAlerts = () => (
  <section
    className="arx-executive-panel"
    aria-labelledby="arx-dashboard-alerts-title"
  >
    <div className="arx-executive-panel__header">
      <div>
        <span>ATENÇÃO</span>
        <h2 id="arx-dashboard-alerts-title">Alertas executivos</h2>
      </div>
      <strong>{executiveAlerts.length}</strong>
    </div>

    <div className="arx-executive-alert-list">
      {executiveAlerts.map(item => (
        <article className="arx-executive-alert" key={item.id}>
          <span
            className={`arx-executive-alert__severity arx-executive-alert__severity--${item.severity}`}
          >
            {item.severity}
          </span>
          <div>
            <strong>{item.title}</strong>
            <p>{item.description}</p>
          </div>
          <time>{item.timestamp}</time>
        </article>
      ))}
    </div>
  </section>
);
